import _classCallCheck from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as EulerFunc from './functions/EulerFunc.js';
import { Mat4 } from './Mat4.js';
var tmpMat4 = new Mat4();
export var Euler = /*#__PURE__*/function (_Array) {
  _inherits(Euler, _Array);

  var _super = _createSuper(Euler);

  function Euler() {
    var _this;

    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
    var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : x;
    var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'YXZ';

    _classCallCheck(this, Euler);

    _this = _super.call(this, x, y, z);
    _this.order = order;

    _this.onChange = function () {};

    return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
  }

  _createClass(Euler, [{
    key: "x",
    get: function get() {
      return this[0];
    },
    set: function set(v) {
      this[0] = v;
      this.onChange();
    }
  }, {
    key: "y",
    get: function get() {
      return this[1];
    },
    set: function set(v) {
      this[1] = v;
      this.onChange();
    }
  }, {
    key: "z",
    get: function get() {
      return this[2];
    },
    set: function set(v) {
      this[2] = v;
      this.onChange();
    }
  }, {
    key: "set",
    value: function set(x) {
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
      var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : x;
      if (x.length) return this.copy(x);
      this[0] = x;
      this[1] = y;
      this[2] = z;
      this.onChange();
      return this;
    }
  }, {
    key: "copy",
    value: function copy(v) {
      this[0] = v[0];
      this[1] = v[1];
      this[2] = v[2];
      this.onChange();
      return this;
    }
  }, {
    key: "reorder",
    value: function reorder(order) {
      this.order = order;
      this.onChange();
      return this;
    }
  }, {
    key: "fromRotationMatrix",
    value: function fromRotationMatrix(m) {
      var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.order;
      EulerFunc.fromRotationMatrix(this, m, order);
      return this;
    }
  }, {
    key: "fromQuaternion",
    value: function fromQuaternion(q) {
      var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.order;
      tmpMat4.fromQuaternion(q);
      return this.fromRotationMatrix(tmpMat4, order);
    }
  }]);

  return Euler;
}( /*#__PURE__*/_wrapNativeSuper(Array));